// Description: Endpoint to create one template
// Updated: 08/09/2025
// Author: Simon Franklin


import axios from 'axios';
import { getTokenData } from '../../../shared/utils/utils';

export async function CreateTemplate(data) {
  try {
    const { token, client_id } = await getTokenData();

    if (!token) throw new Error('Token de autenticação não encontrado');
    if (!client_id) throw new Error('ID do cliente não encontrado');

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/templates/insert`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          Client_ID: client_id,
        },
      }
    );

    return response;  
  } catch (error) {
    console.error('Erro ao criar template:', error);
    throw error;
  }
}
